module.exports = __webpack_public_path__ + "img/Brückenbau.aac1c867.svg";